import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$locale/_authenticated/crm/user-profiles/$userProfileId/$areaKey'
)({
  component: () => null,
});
